import {Component} from '@angular/core';
import {NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault} from '@angular/common';
import {ModalBaseComponent} from '~shared/ng/components/dialog/base/modal-base.component';
import {SimpleModalType} from '~shared/types/dialog.types';
import {TranslateModule} from '@ngx-translate/core';

export type DialogSimpleComponentOptions = {
    title?: string,
    content?: string,
    textParams?: {[key: string]: string | number}
    type: SimpleModalType
};

@Component({
    standalone: true,
    selector: 'app-simple-dialog',
    templateUrl: './dialog.simple.component.html',
    styleUrls: ['./dialog.simple.component.scss'],
    imports: [NgClass, NgIf, TranslateModule, NgSwitch, NgSwitchCase, NgSwitchDefault, NgFor]
})
export class DialogSimpleComponent extends ModalBaseComponent<DialogSimpleComponentOptions, boolean> {
    public readonly SimpleModalType = SimpleModalType;
}
